<template>
  <div>
    {{ datasets }}
      <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data() {
        return {
            
        }
    },
    mounted() {
        let currencySymbol = this.getCurrencyFormat.currency_symbol
        let currency_display = this.currency_display
        let self = this
        const ctx = document.getElementById(this.id);
        new Chart(ctx, {
            type: "bubble",
            data: {datasets: this.datasets}
        })
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Graphs/Bubble.vue